module.exports = __webpack_public_path__ + "media/images/dispatcher-f56dfc9f5455e0b0ddccbb93e307f3d4.svg";